import { render } from "./OcAttachContent.vue?vue&type=template&id=1991c39b&scoped=true"
import script from "./OcAttachContent.vue?vue&type=script&lang=js"
export * from "./OcAttachContent.vue?vue&type=script&lang=js"

import "./OcAttachContent.vue?vue&type=style&index=0&id=1991c39b&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1991c39b"]])

export default __exports__